(() => {
  const grid=document.querySelector('.product-grid');
  if(!grid)return;
  const cards=Array.from(grid.querySelectorAll('.product-card'));
  const toggle=document.querySelector('.filter-toggle');
  const panel=document.querySelector('#collection-filters');
  const available=document.querySelector('#filter-available');
  const coming=document.querySelector('#filter-coming');
  const sort=document.querySelector('#collection-sort');
  const status=document.querySelector('.collection-count');
  const empty=document.querySelector('.collection-empty');
  if(!toggle||!panel||!available||!coming||!sort||!status||!empty)return;
  const priced=cards.length>0&&cards.every(card=>Number.isFinite(Number(card.dataset.price))&&card.dataset.price!=='');
  sort.querySelectorAll('option[value^="price-"]').forEach(option=>{option.disabled=!priced;});
  toggle.addEventListener('click',()=>{
    panel.hidden=!panel.hidden;
    toggle.setAttribute('aria-expanded',String(!panel.hidden));
  });
  const title=card=>card.querySelector('h3')?.textContent||'';
  function render(){
    const selected=[];
    if(available.checked)selected.push('available');
    if(coming.checked)selected.push('coming-soon');
    const ordered=cards.slice();
    if(sort.value==='title-ascending')ordered.sort((a,b)=>title(a).localeCompare(title(b)));
    else if(sort.value==='title-descending')ordered.sort((a,b)=>title(b).localeCompare(title(a)));
    else if(priced&&sort.value==='price-ascending')ordered.sort((a,b)=>Number(a.dataset.price)-Number(b.dataset.price));
    else if(priced&&sort.value==='price-descending')ordered.sort((a,b)=>Number(b.dataset.price)-Number(a.dataset.price));
    let count=0;
    ordered.forEach(card=>{
      card.hidden=selected.length>0&&!selected.includes(card.dataset.availability||'coming-soon');
      if(!card.hidden)count++;
      grid.append(card);
    });
    status.textContent=count+' '+(count===1?'preview':'previews');
    empty.hidden=count>0;
    grid.hidden=count===0;
  }
  [available,coming,sort].forEach(control=>control.addEventListener('change',render));
  document.querySelectorAll('.filter-reset').forEach(button=>button.addEventListener('click',()=>{available.checked=false;coming.checked=false;render();}));
  render();
})();
